import formatRun from './formatRun'

interface Props {
    lane?: string | null
    lot?: string | null
}

const formatLaneLot = (props: Props | null | undefined): string => {
    if (!props) {
        return ''
    }

    const { lane, lot } = props

    if (lane?.length && lot?.length) {
        return formatRun(`${lane}-${lot}`)
    }

    if (lane?.length) {
        return lane
    }

    if (lot?.length) {
        return lot
    }

    return ''
}

export default formatLaneLot
